export enum PermissionOperations {
  CREATE = "Create",
  READ = "Read",
  UPDATE = "Update",
  DELETE = "Delete",
}

export enum PermissionNames {
  AWARD = "Award", // -
  BASE_SEASON_ENTITY_STATISTIC = "BaseSeasonEntityStatistic", // --
  BASE_SEASON_PERSON_STATISTIC = "BaseSeasonPersonStatistic", // --
  CAREER_STATISTIC = "CareerStatistic", // -
  ENTITY_GROUP = "EntityGroup", // Org entityGroup
  COMPETITION = "Competition", // org competition
  COMPETITION_STATISTIC = "CompetitionStatistic", // --
  CONDUCT = "Conduct", // -- we will
  CONFERENCE = "Conference", // org
  DIVISION = "Division", // org
  ENTITY = "Entity", // org
  ENTITY_FIXTURE_HISTORY = "EntityFixtureHistory", // --
  ENTITY_FIXTURE_STATISTIC = "EntityFixtureStatistic", // --
  FIXTURE = "Fixture", // Season level fixtures
  FIXTURE_ENTITY = "FixtureEntity", // team in fixture
  FIXTURE_PERSON = "FixturePerson", //same as entity by for individual
  FIXTURE_SETTINGS = "FixtureSettings", //reset statistics,
  FIXTURE_LIVE_SUMMARY = "FixtureLiveSummary", // --
  FIXTURE_PLAY_BY_PLAY = "FixturePlayByPlay", //--
  FIXTURE_ROSTER = "FixtureRoster", // --
  IMAGE = "Image", // ALl images,
  LEADER_CRITERIA_SET = "LeaderCriteriaSet", // org
  LEADER_QUALIFIER = "LeaderQualifier", //  org
  LEAGUE = "League", // org
  MANAGE_EXTERNAL_IDS = "ManageExternalIds", // --
  MATCH_PROFILE = "MatchProfile", //org
  MATCH_PROGRESSIONS = "MatchProgressions", //--
  PERSON = "Person", // org
  PERMISSIONS = "Permissions",
  PERSON_FIXTURE_HISTORY = "PersonFixtureHistory", // --
  PERSON_FIXTURE_STATISTIC = "PersonFixtureStatistic", // --
  POOL = "Pool", // season
  RANKING = "Ranking", // --
  REPORT = "Report", // season will be
  ROLES = "Roles", // teams/staff and officials season level
  ROUND = "Round", // season level
  SEASON = "Season", //season + competition/season
  SEASON_ENTITY = "SeasonEntity", // season teams
  SEASON_ENTITY_PLACING = "SeasonEntityPlacing", // ??
  SEASON_LEADER = "SeasonLeader", // --
  SEASON_PERSON = "SeasonPerson", // season teams for individual sport
  SEASON_PERSON_PLACING = "SeasonPersonPlacing", // --
  SEASON_ROSTER = "SeasonRoster", // roster teams season
  SEASON_SERIES = "SeasonSeries", // season lvl
  SEASON_STATISTIC = "SeasonStatistic", // Season level => team stats && player stats
  SITE = "Site", // org and season
  STAGE = "Stage", // org and season
  STANDING = "Standing", // season level
  STANDING_ADJUSTMENT = "StandingAdjustment", //season level
  STANDING_CONFIGURATION = "StandingConfiguration", //org
  TRANSFER = "Transfer", // --
  VENUE = "Venue", // org + season
  ORGANIZATION = "Organization", // full org,
  UNIFORM = "Uniform",
}
